var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-container"},[_c('div',{staticClass:"login-side-bar"},[_c('div',{staticClass:"input-form"},[_c('carousel'),_c('router-view',{on:{"loadForm":function($event){return _vm.loadSlider($event)}}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }